import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * twMerge extended with the semantic type tokens from the app @theme blocks.
 * Without this, tailwind-merge classifies `text-body` etc. as text COLORS, so
 * `cn("text-body", "text-muted-foreground")` would drop `text-body`.
 * Keep this list in sync with the `--text-*` tokens in each app's index.css.
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: [
        "display",
        "headline",
        "metric",
        "title",
        "prose",
        "body",
        "control",
        "label",
        "caption",
        "badge",
        "section",
        "overline",
        "code",
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
